import styled from 'styled-components';

import PrimaryButtonLoading from '~src/shared/buttons/loadingButtons/PrimaryButtonLoading';

export const StyledForm = styled.form`
  margin-bottom: 75px;
`;

export const AttrTypesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
`;

export const AttrLabel = styled.label<{ $itemsLength: number }>`
  min-width: 150px;
  margin: 0 10px 10px 0;
  flex: 1 1 ${({ $itemsLength }) => 1140 / $itemsLength - ($itemsLength - 1) * 10}px;

  &:last-child {
    margin-right: 0;
  }
`;

export const CreateSurveyBtn = styled(PrimaryButtonLoading)`
  margin-left: 15px;
`;

export const CreateTeamSurveyBtn = styled(PrimaryButtonLoading)`
  margin-left: 15px;
  margin-top: 100px;
`;
